import ApiService from '@/core/services/api.service';

const subtitleCache = {};
const pendingRequests = {};

function canHaveSubtitles(videoUrl) {
    return Boolean(videoUrl && !videoUrl.startsWith('blob:') && !videoUrl.startsWith('data:'));
}

function parseVttTime(value) {
    const cleaned = String(value)
        .trim()
        .replace(',', '.');
    const parts = cleaned.split(':');
    if (parts.length === 3) {
        return Number(parts[0]) * 3600 + Number(parts[1]) * 60 + Number(parts[2]);
    }
    if (parts.length === 2) {
        return Number(parts[0]) * 60 + Number(parts[1]);
    }
    return Number(cleaned) || 0;
}

export function parseVttCues(vttContent) {
    const cues = [];
    const normalized = String(vttContent)
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n');
    const blocks = normalized.split(/\n{2,}/);

    blocks.forEach(block => {
        const lines = block
            .split('\n')
            .map(line => line.trimEnd())
            .filter(line => line !== '');
        const timeIndex = lines.findIndex(line => line.includes('-->'));
        if (timeIndex === -1) {
            return;
        }
        const match = lines[timeIndex].match(/([^\s]+)\s+-->\s+([^\s]+)/);
        if (!match) {
            return;
        }
        const text = lines.slice(timeIndex + 1).join('\n');
        if (!text) {
            return;
        }
        cues.push({
            start: parseVttTime(match[1]),
            end: parseVttTime(match[2]),
            text
        });
    });

    return cues;
}

export function loadSubtitleContent(videoUrl) {
    if (!canHaveSubtitles(videoUrl)) {
        return Promise.resolve(null);
    }
    if (Object.prototype.hasOwnProperty.call(subtitleCache, videoUrl)) {
        return Promise.resolve(subtitleCache[videoUrl]);
    }
    if (pendingRequests[videoUrl]) {
        return pendingRequests[videoUrl];
    }

    pendingRequests[videoUrl] = ApiService.query(`${process.env.VUE_APP_API_URL}/academy/subtitles`, {
        params: { url: videoUrl }
    })
        .then(response => {
            const content = response.data && response.data.content ? response.data.content : null;
            subtitleCache[videoUrl] = content;
            return content;
        })
        .catch(() => {
            subtitleCache[videoUrl] = null;
            return null;
        })
        .finally(() => {
            delete pendingRequests[videoUrl];
        });

    return pendingRequests[videoUrl];
}

function applySubtitles(videoEl, vttContent) {
    for (let i = 0; i < videoEl.textTracks.length; i++) {
        if (videoEl.textTracks[i].label === 'Français') {
            return;
        }
    }

    const track = videoEl.addTextTrack('subtitles', 'Français', 'fr');
    parseVttCues(vttContent).forEach(cue => {
        track.addCue(new VTTCue(cue.start, cue.end, cue.text));
    });
    track.mode = 'hidden';
}

export function attachVideoSubtitles(videoEl, videoUrl) {
    if (!videoEl || !canHaveSubtitles(videoUrl)) {
        return Promise.resolve();
    }

    return loadSubtitleContent(videoUrl).then(content => {
        if (!content || !videoEl.isConnected) {
            return;
        }
        applySubtitles(videoEl, content);
    });
}
